import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const CloudRainWind: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242' }],
    ['path', { d: 'm9.2 22 3-7' }],
    ['path', { d: 'm9 13-3 7' }],
    ['path', { d: 'm17 13-3 7' }],
  ],
];

export default CloudRainWind;
